import * as React from 'react'

import Settings from 'Settings'
import SentryMock from './SentryMock'
import {ignoreUrls, ignoreErrors} from './ignorePatterns'
import {connect} from 'react-redux'

import withURLParamsMapper from 'components/data/URLParams/withURLParamsMapper'

type InitializeSentryType = {
  anonymousId: string
  children: React.ReactNode
  params: Record<string, string>
}

class InitializeSentry extends React.PureComponent<InitializeSentryType> {
  constructor(props) {
    super(props)
    const {anonymousId} = props.params
    const SENTRY_DSN = Settings.get('REACT_APP_SENTRY_DSN')

    try {
      if (typeof Sentry === 'object' && SENTRY_DSN) {
        const sentryOpts = {
          dsn: SENTRY_DSN,
          environment: Settings.get('REACT_APP_ENV'),
          release: Settings.get('REACT_APP_VERSION'),
          blacklistUrls: ignoreUrls,
          ignoreErrors
        }

        Sentry.init(sentryOpts)
        if (anonymousId) {
          Sentry.configureScope(function (scope) {
            scope.setUser({id: anonymousId})
          })
        }
      }
    } catch (error) {
      console.error('Error initializing Sentry.', error)
      window.Sentry = SentryMock
    }
  }

  render() {
    return null
  }
}

export default withURLParamsMapper(connect(null, null)(InitializeSentry))
